import {
  Component,
  HostBinding,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { Adjustment } from 'app/event/models/adjustment';
import { OnyxEvent } from '../../models/event';
import { ConfirmationModalComponent } from 'app/shared/confirmation-modal/confirmation-modal.component';
import { CurrencyPipe } from '@angular/common';
import { AdjustmentStore } from '../../service/adjustment.store';
import { ReservationStatusCode } from '../../models/reservation-status-code.enum';
import { TranslateService } from '@ngx-translate/core';
import { ErrorHandlerService } from '../../../shared/utils/error-handler.service';
import { AdjustmentUtils } from '../../utils/adjustment-utils';
import { ReservationStore } from 'app/event/service/reservation-store';
import { ConfirmationModalConfig } from '../../../shared/confirmation-modal/confirmation-modal-config';
import { Payment } from '../../models/payment';

@Component({
  selector: 'pioneer-payment-adjustment-equation',
  templateUrl: './payment-adjustment-equation.component.html'
})
export class PaymentAdjustmentEquationComponent implements OnInit {

  @HostBinding('class') defaultClasses = 'col form-container due-amount';
  @HostBinding('class.has-adjust') hasAdjustmentCssClass = false;

  @ViewChild(ConfirmationModalComponent)
  confirmationModal: ConfirmationModalComponent;

  @Input() isEditMode = false;

  @Input()
  @HostBinding('class.status-rejected')
  strikeThroughPaymentLines = false;

  confirmationModalConfig = new ConfirmationModalConfig();

  private adjustmentToRemove: Adjustment = null;
  private onyxEvent: OnyxEvent;

  constructor(
    private currencyPipe: CurrencyPipe,
    private adjustmentStore: AdjustmentStore,
    private translateService: TranslateService,
    private errorHandlerService: ErrorHandlerService,
    private reservationStore: ReservationStore
  ) {}

  @Input()
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  ngOnInit() {

    this.areThereAnyAdjustments().subscribe((value: boolean) => {
      this.hasAdjustmentCssClass = value;
    });

    if (!this.onyxEvent) {
      this.errorHandlerService.throw(
        'Input property onyxEvent is null in AddPaymentComponent',
        this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
          property: 'onyxEvent',
          className: 'PaymentEquationComponent'
        })
      );
    }

  }

  get adjustments(): Observable<List<Adjustment>> {
    return this.adjustmentStore.adjustments;
  }

  get calculatedPayment(): Observable<number> {
    return this.adjustmentStore.getCalculatedPayment(ReservationStatusCode.CHECKED_OUT)
  }

  get totalCommissions(): Observable<number> {
    return this.reservationStore.getTotalCommissions(ReservationStatusCode.CHECKED_OUT);
  }

  areThereAnyAdjustments(): Observable<boolean> {
    return this.adjustments.map(list => list.size > 0);
  }

  getAdjustmentCssClass(adjustment: Adjustment): string {
    if (AdjustmentUtils.isAdjustmentTypePositive(adjustment.adjustmentType)) {
      return 'adjustment up';
    } else {
      return 'adjustment down';
    }
  }

  getAdjustmentAmountCssClass(adjustment: Adjustment): string {
    if (AdjustmentUtils.isAdjustmentTypePositive(adjustment.adjustmentType)) {
      return 'currency text-success';
    } else {
      return 'currency text-warning';
    }
  }

  confirmBeforeDeletingAdjustment(adjustment: Adjustment) {
    this.adjustmentToRemove = adjustment;

    // set up the title of the confirmation modal
    const label = 'EVENT.COMMISSION.DELETE_ADJUSTMENT_CONFIRMATION_TITLE';
    const amount = adjustment.adjustmentAmount;
    const currencyFormat = this.currencyPipe.transform(amount, 'USD', true);
    const params = { adjustmentAmount: currencyFormat };
    this.confirmationModalConfig.title = this.translateService.instant(label, params);

    this.confirmationModal.open();
  }

  deleteAdjustment(adjustmentId: number, eventId: number): void {
    this.adjustmentStore
      .deleteAdjustment(adjustmentId, eventId)
      .subscribe();
  }

  confirmBeforeDeletingAdjustmentHandler(value: any) {
    if (value) {
      const adjustmentId = this.adjustmentToRemove.eventAdjustmentId;
      const eventId = this.onyxEvent.eventId;
      this.deleteAdjustment(adjustmentId, eventId);
    }
    this.adjustmentToRemove = null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/payment-adjustment-calculation/payment-adjustment-equation.component.ts